import { makePropCacheMixin } from '../utils/cache'

export const listenersMixin = makePropCacheMixin('$listeners', 'bvListeners')
